
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/2016-09-21-sunset",
      function () {
        return require("private-next-pages/posts/2016-09-21-sunset.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/posts/2016-09-21-sunset"])
      });
    }
  